// extracted by mini-css-extract-plugin
export default {"fileDetails":"media_manager_header_fileDetails__pXy5v","fileNameAndPath":"media_manager_header_fileNameAndPath__96XV6"};